import { ORGANIZATION_ID, ORGANIZATION_NAME, SERVICE_OGP_IMAGE, SITE_URL } from './constants'

/** 子ページの Service 等から参照する Organization（TOP の Corporation と同一 @id） */
export const organizationProvider = {
  '@id': ORGANIZATION_ID,
}

export const organizationPublisher = {
  '@type': 'Organization',
  name: ORGANIZATION_NAME,
  url: `${SITE_URL}/`,
}

export const organizationAuthor = {
  '@type': 'Organization',
  name: ORGANIZATION_NAME,
  url: `${SITE_URL}/`,
}

/** 必要に応じてインライン展開する場合の provider 詳細（schema_base 互換） */
export const organizationProviderInline = {
  '@type': 'Corporation',
  '@id': ORGANIZATION_ID,
  name: ORGANIZATION_NAME,
  legalName: ORGANIZATION_NAME,
  alternateName: 'i3DESIGN Co., Ltd.',
  url: `${SITE_URL}/`,
  logo: SERVICE_OGP_IMAGE,
  image: SERVICE_OGP_IMAGE,
  telephone: '+81-3-6419-7700',
  address: {
    '@type': 'PostalAddress',
    addressLocality: '港区赤坂',
    addressRegion: '東京都',
    addressCountry: 'JP',
    postalCode: '1070052',
    streetAddress: '八丁目1番22号 NMF青山一丁目ビル3階',
  },
}
